module.exports = __webpack_public_path__ + "img/auchan.bcd1e360.svg";